module.exports = __webpack_public_path__ + "img/16-1.d396b5e9.svg";